export const REACT_APP_BASE_URL = 'https://dev-api.trusteddev.ai/'
// export const REACT_APP_BASE_URL = 'https://stg-api.trusteddev.ai/'
export const ENCRYPT_KEY = 'trusted_dev_encrypt_key'